module.exports = __webpack_public_path__ + "static/media/IMG_3052.4a1695f6.JPG";